module.exports = __webpack_public_path__ + "static/media/avc_sugar.5e372bdf.svg";